import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-agregar-listado-pacientes',
  templateUrl: './agregar-listado-pacientes.component.html',
  styleUrls: ['./agregar-listado-pacientes.component.css']
})
export class AgregarListadoPacientesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
